module.exports = __webpack_public_path__ + "img/inst-1.e4fb10f2.png";